module.exports = "https://coursera_assets.s3.amazonaws.com/images/1a2efe11d1f10972c83a233d984704b3.png";